import { TDictObject } from 'src/api/directories/types';
import { hasValue } from 'src/shared/utils/common';
import { Directories } from 'src/store/directories/directories.store';

import { TGeologicalLoadKeys, GEOLOAD_PROPERTIE_NAMES } from './geological-load-service';

export const isGeoLoadField = (fieldId: string): fieldId is TGeologicalLoadKeys => {
  return GEOLOAD_PROPERTIE_NAMES.includes(fieldId as any);
};

export const getExtractionVolume = (
  directoryMap: Map<number, TDictObject>,
  coreSamplingIntervalValue: number[],
): number | null => {
  const extractionVolume = coreSamplingIntervalValue.reduce((acc: number | null, coreSamplingIntervalId) => {
    const currValueExtractionVolume = directoryMap.get(coreSamplingIntervalId)?.data['extractionVolume'];

    if (!hasValue(currValueExtractionVolume) || typeof currValueExtractionVolume !== 'number') {
      return acc;
    }

    if (!hasValue(acc)) {
      return currValueExtractionVolume;
    }

    return acc + currValueExtractionVolume;
  }, null);

  return extractionVolume;
};

export const getCoreSamplingDayAmount = (
  directoryMap: Map<number, TDictObject>,
  coreSamplingIntervalValue: number[],
): number | null => {
  const coreSamplingDayAmount = coreSamplingIntervalValue.reduce((acc: number | null, coreSamplingIntervalId) => {
    const currValueCoreSamplingDayAmount = directoryMap.get(coreSamplingIntervalId)?.data['coreSamplingDayAmount'];

    if (!hasValue(currValueCoreSamplingDayAmount) || typeof currValueCoreSamplingDayAmount !== 'number') {
      return acc;
    }

    if (!hasValue(acc)) {
      return currValueCoreSamplingDayAmount;
    }

    return acc + currValueCoreSamplingDayAmount;
  }, null);

  return coreSamplingDayAmount;
};

export const getTestingFormationWorkDayAmount = (
  geologicalLoadDirectory: TDictObject,
  testingFormationWorkAmountValue: number | null,
): number | null => {
  const dayAmountPerIptRun = geologicalLoadDirectory.data['dayAmountPerIptRun'];

  if (!hasValue(dayAmountPerIptRun) || typeof dayAmountPerIptRun !== 'number') {
    console.error('dayAmountPerIptRun is not presented or has invalid type', dayAmountPerIptRun);
    return null;
  }

  if (!hasValue(testingFormationWorkAmountValue)) {
    return null;
  }

  return testingFormationWorkAmountValue * dayAmountPerIptRun;
};

export const getDaysAmountOfDataInterpretationOperation = (
  geologicalLoadDirectory: TDictObject,
  numberOfDataInterpretationOperationsValue: number | null,
) => {
  const dayAmountPerDataInterpretationOperation =
    geologicalLoadDirectory.data['dayAmountPerDataInterpretationOperation'];

  if (
    !hasValue(dayAmountPerDataInterpretationOperation) ||
    typeof dayAmountPerDataInterpretationOperation !== 'number'
  ) {
    console.error(
      'dayAmountPerDataInterpretationOperation is not presented or has invalid type',
      dayAmountPerDataInterpretationOperation,
    );
    return null;
  }

  if (!hasValue(numberOfDataInterpretationOperationsValue)) {
    return null;
  }

  return dayAmountPerDataInterpretationOperation * numberOfDataInterpretationOperationsValue;
};

export const getStageSlug = (directories: Directories, stageTypeId: number): string | null => {
  const directory = directories.getObject('GOplan_Dict_WellLifeCycleStage');

  if (!directory) {
    console.error('cannot find GOplan_Dict_WellLifeCycleStage directory');
    return null;
  }

  const slug = directory.find((dir) => dir.id === stageTypeId)?.data.slug;

  if (!slug || typeof slug !== 'string') {
    return null;
  }

  return slug;
};
